import axiosClient from "./axiosClient";

// const serviceUrl = "http://42.96.44.215:10002";
// http://42.96.44.215:10002/qlkhambenh/refraction/list-refraction?page=1&size=10
const glasses = {
  getLitGlasses: async (page) => {
    const params = { page: page, size: 10 };
    const url = "/store/glasses-receipt/list-glasses-receipt";
    const response = await axiosClient.get(url, { params: params });

    return response;
  },
  getLitGlassesById: async (id) => {
    const url = `/qlkhambenh/refraction/id`;
    const response = await axiosClient.get(url, { params: { id } });
    return response;
  },
  updateGlasses: async (data) => {
    const url = "/qlkhambenh/refraction";
    const response = await axiosClient.put(url, data);
    return response;
  },
  deleteAGlasses: async (id) => {
    const url = "/qlkhambenh/refraction";
    const response = await axiosClient.delete(url, { params: { id } });
    return response;
  },
};

export default glasses;
